// extracted by mini-css-extract-plugin
export default {"c3Box":"C3_c3Box__ekYwn","textBox":"C3_textBox__Hk0ih"};